import { Currency } from "components/CustomCurrency/currency";

export function formatTableSalesBySector(data) {
  console.log("data: ", data);

  var aditionalColumns = [];
  Object.keys(data[0].sectors).forEach((sector) => {
    aditionalColumns.push({
      Header: data[0].sectors[sector].name,
      accessor: String(sector),
    });
  });

  let rows = [];
  let count = 1;
  data.forEach((elem) => {
    const knownFields = {
      nro: count,
      empresa: elem.company,
      ventas: <Currency value={elem.total} />,
    };
    Object.keys(elem.sectors).forEach((sectorId) => {
      knownFields[sectorId] = <Currency value={elem.sectors[sectorId].sale} />;
    });

    rows.push(knownFields);
    count++;
  });

  return {
    columns: [
      {
        Header: "Nro",
        accessor: "nro",
        width: "5%",
      },
      {
        Header: "Empresa",
        accessor: "empresa",
        width: "30%",
      },
      {
        Header: "Ventas Totales",
        accessor: "ventas",
      },
    ].concat(aditionalColumns),
    rows: rows,
  };
}
